import { render } from "./NotificationToast.vue?vue&type=template&id=b7bfc000&scoped=true"
import script from "./NotificationToast.vue?vue&type=script&lang=js"
export * from "./NotificationToast.vue?vue&type=script&lang=js"

import "./NotificationToast.vue?vue&type=style&index=0&id=b7bfc000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bfc000"]])

export default __exports__